export default __webpack_public_path__ + "static/media/male-avatar.9d376a55.png";